import { Link, Outlet } from "react-router-dom";
import BrandHeader from "./BrandHeader";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrandHeader
        rightSlot={
          <>
            <Link
              to="/dashboard/login"
              className="text-muted-foreground hover:text-foreground"
            >
              Log in
            </Link>
            <Link
              to="/dashboard/signup"
              className="rounded-md bg-primary px-3 py-1.5 text-primary-foreground hover:opacity-90"
            >
              Sign up
            </Link>
          </>
        }
      />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
